import script from "./index.vue?vue&type=script&setup=true&lang=tsx"
export * from "./index.vue?vue&type=script&setup=true&lang=tsx"

import "./index.vue?vue&type=style&index=0&id=56c94251&lang=less&scoped=true"
import "./index.vue?vue&type=style&index=1&id=56c94251&lang=less"

import exportComponent from "/opt/teams-app/node_modules/.pnpm/vue-loader@17.0.0_webpack@5.74.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56c94251"]])

export default __exports__